<template>
  <app-link
    :link="link"
    v-if="src"
  >
    <img
      class="logo__img"
      :src="src"
      :alt="client.name"
    >
  </app-link>
</template>

<script setup>
import { computed } from 'vue'
import { useClientStore } from '@/stores/ClientStore'
import { useI18n } from '@/vendors/i18n'
import { get as _get } from 'lodash'
import Link from '@/classes/links/Link'

import AppLink from '&/atoms/AppLink'

const { component } = defineProps({
  component: { type: Object, required: true }
})

const { getClient } = useClientStore()
const { translate } = useI18n()

const { client } = getClient()

const { logo_url, link: externalLink = {} } = component.attributes
const link = new Link({
  url: externalLink,
  target_url: '/'
})

const src = computed(() => translate(logo_url) || _get(client.value, 'logo.medium.url'))
</script>

<style lang="scss" scoped>
.logo {
  &__img {
    max-width: 150px;
    display: block;

    @include mq(sm) {
      max-width: 180px;
    }
  }
}
</style>
